import React from 'react';
import Skeleton from 'react-loading-skeleton';

export default function SocialLoginSkeleton({ contentHeight, numOfSkeleton }) {
    return (
        <div id="socialLogin" className="social-login">
            {Array.from({ length: numOfSkeleton || 1 }, (_, index) => (
                <div className="social-login__link social-login__link--neutral social-login__link" key={index}>
                    <Skeleton height={contentHeight || 15} width={20} />
                    <Skeleton height={contentHeight || 15} width={80} />
                </div>
            ))}
        </div>
    );
}
